// extracted by mini-css-extract-plugin
export var label = "_k4-2";
export var slideContainer = "_k4-0";
export var slider = "_k4-1";